import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { toastErrorLog } from '../../../helpers/toastErrorLog'
import {
  setFiltrosCaracteristicas,
  setFiltrosSeleccionados,
  setCaracteristicasActuales,
  setMapEtiquetaIds,
  setFiltroLocal,
  setCategoria as setCategoriaStore,
  goBackToCategoria,
  resetCategorias as resetCategoriasStore,
  resetFiltrosLocales,
  resetCaracteristicas,
  setPaginaFiltros,
  setReiniciaFiltros
} from '../../../slices/filterSlice'
import * as categoriasService from '../../servicios/categoriasService'
import { buscarMetadatos } from '../../servicios/publicacionesService'
import { buscarTodosPorIdCategoria } from '../../servicios/subcategoriaService'

const SEGMENTOS_SECCION = 2
const hoy = Date.now()

export const useFiltros = (publicaciones) => {
  const [categorias, setCategorias] = useState([])
  const [vendedor, setVendedor] = useState({ id: 0, label: '' })
  const [cargandoFiltros, setCargandoFiltros] = useState(true)
  const [cargandoCategorias, setCargandoCategorias] = useState(true)

  const {
    categoriaSeleccionada,
    filtrosSeleccionados,
    filtrosLocales,
    paginaFiltros,
    reiniciaFiltros
  } = useSelector((state) => state.filters)
  const dispatch = useDispatch()
  const location = useLocation()

  const buscarAtributos = async (publicaciones, { esFinal, esRaiz }) => {
    try {
      const categoriaInicial = categoriaSeleccionada

      if (!publicaciones?.length) {
        return
      }

      const ids = publicaciones.map((p) => p.idPublicacion)
      const { data: dataPub = [] } = await buscarMetadatos(ids)
      if (categoriaSeleccionada !== categoriaInicial) {
        return
      }
      dispatch(setCaracteristicasActuales(dataPub))

      let dataFiltrada = []

      if (esFinal) {
        dataFiltrada = dataPub
      } else if (!esRaiz) {
        const { data: dataCat } = await categoriasService.buscarAtributos(categoriaSeleccionada)
        if (categoriaSeleccionada !== categoriaInicial) {
          return
        }

        const importantesArr = dataCat.filter((a) => Number(a.catalogRequired) === 1)
        const idToLabel = new Map(importantesArr.map((a) => [a.idMetaDato, a.Etiqueta ?? '']))

        dataFiltrada = dataPub
          .filter((car) => idToLabel.has(car.idMetaDato))
          .map((car) => ({
            ...car,
            etiqueta: idToLabel.get(car.idMetaDato) || car.etiqueta
          }))
      }

      const filtros = {}
      const filtrosArray = {}
      const filtrosSelected = {}
      const etiquetaIds = {}

      dataFiltrada.forEach((car) => {
        const key = car.etiqueta
        let valor = car.valor
        if (car.idMetadatoTipo === 'string' && (!valor || valor.trim() === '')) {
          return
        }
        if (car.idMetadatoTipo === 'boolean') {
          valor = valor.toUpperCase() === 'SI' || valor.toUpperCase() === 'YES' ? 'SI' : 'NO'
        }
        if (!filtros[key]) {
          filtros[key] = new Set()
          etiquetaIds[key] = new Set()
        }
        filtros[key].add(String(valor).toLowerCase())
        etiquetaIds[key].add(car.idMetaDato)
      })

      Object.keys(filtros)
        .sort()
        .forEach((key) => {
          const arr = Array.from(filtros[key])
            .filter((v) => v !== '')
            .sort((a, b) => a.localeCompare(b))
          if (arr.length > 0) {
            filtrosArray[key] = arr
            filtrosSelected[key] = filtrosSelected[key] ?? ''
          }
        })

      dispatch(
        setMapEtiquetaIds(
          Object.fromEntries(Object.entries(etiquetaIds).map(([k, v]) => [k, Array.from(v)]))
        )
      )
      dispatch(setFiltrosCaracteristicas(filtrosArray))
      if (Object.keys(filtrosSeleccionados).length === 0) {
        dispatch(setFiltrosSeleccionados(filtrosSelected))
      }
    } catch (error) {
      toastErrorLog(error, 'Error al procesar filtros', 'buscarFiltros')
    }
  }

  const buscarCategorias = async (publicaciones) => {
    try {
      const { data } = await buscarTodosPorIdCategoria(categoriaSeleccionada || 0, false)
      const esFinal = data.length === 0
      const esRaiz = !categoriaSeleccionada

      if (!esFinal) {
        const cats = data
          .map(({ idSubCategoria, descripcion, tieneSubCategoria }) => {
            if (publicaciones.some((p) => p.categoriaRoot?.includes(idSubCategoria))) {
              return {
                value: idSubCategoria,
                label: tieneSubCategoria
                  ? descripcion
                  : `${descripcion} (${publicaciones.filter((p) => p.idCategoria === +idSubCategoria).length})`,
                tieneSubCategoria
              }
            }
            return null
          })
          .filter(Boolean)
        setCategorias(cats)
        await buscarAtributos(publicaciones, { esFinal, esRaiz })
      } else {
        setCategorias([])
        await buscarAtributos(publicaciones, { esFinal, esRaiz })
      }
    } catch (error) {
      toastErrorLog(error, 'Error al cargar las categorias', 'filtros')
      setCategorias([])
      await buscarAtributos(publicaciones, { esFinal: true, esRaiz: !categoriaSeleccionada })
    }
  }

  useEffect(() => {
    const seccionActual = location.pathname
      .split('/')
      .filter(Boolean)
      .slice(0, SEGMENTOS_SECCION)
      .join('/')

    const preservarFiltros =
      location.state?.vieneConFiltroCategoria || location.state?.desdeCategoria

    const mismaSeccionTiendas =
      (seccionActual === 'TiendasOficiales' && paginaFiltros?.endsWith('TiendasOficiales')) ||
      (paginaFiltros === 'TiendasOficiales' && seccionActual?.endsWith('TiendasOficiales'))

    if (
      reiniciaFiltros ||
      (!preservarFiltros &&
        !mismaSeccionTiendas &&
        paginaFiltros !== null &&
        paginaFiltros !== seccionActual)
    ) {
      limpiarTodosFiltros()
    }

    dispatch(setPaginaFiltros(seccionActual))
    setCargandoFiltros(false)
  }, [location.pathname])

  useEffect(() => {
    if (publicaciones?.length > 0) {
      buscarCategorias(publicaciones)
      setCargandoCategorias(false)
    } else {
      setCategorias([])
      dispatch(setCaracteristicasActuales([]))
      setCargandoCategorias(false)
    }
  }, [publicaciones, categoriaSeleccionada])

  const resetCategorias = () => {
    dispatch(resetCategoriasStore())
    dispatch(setCaracteristicasActuales([]))
    dispatch(setMapEtiquetaIds({}))
    dispatch(setFiltrosCaracteristicas({}))
    dispatch(resetCaracteristicas())
  }

  const onChangeCategoria = (id, label) => dispatch(setCategoriaStore({ id, label }))
  const categoriaAnterior = (id) => dispatch(goBackToCategoria(id))
  const onResetCategorias = () => resetCategorias()

  const limpiarTodosFiltros = () => {
    dispatch(setFiltrosSeleccionados({}))
    dispatch(resetFiltrosLocales())
    dispatch(setReiniciaFiltros(false))
    resetCategorias()
  }

  const handleFechaChange = (key, otraKey) => (value) => {
    if (!value) {
      dispatch(setFiltroLocal({ key, value: null }))
      return
    }
    const ts = new Date(value).getTime()
    const otra = filtrosLocales[otraKey] ? new Date(filtrosLocales[otraKey]).getTime() : null
    if (key.includes('Desde') && ((otra && ts > otra) || ts > hoy)) {
      return
    }
    if (key.includes('Hasta') && ((otra && ts < otra) || ts > hoy)) {
      return
    }
    dispatch(setFiltroLocal({ key, value }))
  }

  return {
    categorias,
    setCategorias,
    categoriaSeleccionada,
    vendedor,
    setVendedor,
    resetCategorias,
    onChangeCategoria,
    categoriaAnterior,
    onResetCategorias,
    limpiarTodosFiltros,
    handleFechaChange,
    cargandoFiltros,
    cargandoCategorias
  }
}
